"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InteractionTagSecondary: function() {
        return _InteractionTagSecondary.InteractionTagSecondary;
    },
    interactionTagSecondaryClassNames: function() {
        return _useInteractionTagSecondaryStylesstyles.interactionTagSecondaryClassNames;
    },
    renderInteractionTagSecondary_unstable: function() {
        return _renderInteractionTagSecondary.renderInteractionTagSecondary_unstable;
    },
    useInteractionTagSecondaryStyles_unstable: function() {
        return _useInteractionTagSecondaryStylesstyles.useInteractionTagSecondaryStyles_unstable;
    },
    useInteractionTagSecondary_unstable: function() {
        return _useInteractionTagSecondary.useInteractionTagSecondary_unstable;
    }
});
const _InteractionTagSecondary = require("./InteractionTagSecondary");
const _renderInteractionTagSecondary = require("./renderInteractionTagSecondary");
const _useInteractionTagSecondary = require("./useInteractionTagSecondary");
const _useInteractionTagSecondaryStylesstyles = require("./useInteractionTagSecondaryStyles.styles");
